import { pick } from 'ramda';
import { parse } from 'query-string';

import { USER_FETCHED } from 'app/features/user/actionTypes';
import {
  REFERRING_DOMAIN,
  UTM_SOURCE,
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  UTM_TERM,
  UTM_CONTENT,
} from 'app/router/constants/urlParameters';
import { referrer as referrerSelector } from 'app/router/selectors';

const traits = (user, getState) => {
  const utm = pick(
    [UTM_SOURCE, UTM_MEDIUM, UTM_CAMPAIGN, UTM_TERM, UTM_CONTENT],
    parse(window.location.search),
  );
  const referrer = referrerSelector(getState());

  return {
    email: user.email,
    subStatus: user.accessType || 'free',
    externalUserId: user.id,
    createdAt: user.createdAt,
    ...utm,
    referrer,
    [REFERRING_DOMAIN]: referrer && new URL(referrer).hostname,
  };
};

const identify = {
  [USER_FETCHED]: (getState, { payload: user }) =>
    user.id && {
      type: 'identify',
      name: user.id,
      properties: traits(user, getState),
    },
};

export default identify;
